export enum MessagesOrder {
    creationTimeAsc = 1,
    creationTimeDesc = 2,
}
